"use client";

import { ChevronsUpDown } from "lucide-react";
import { Label, Input } from "visuais";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "visuais";
import { usePrenotaStore } from "@PN/inclusao";

interface PixSectionProps {
  className?: string;
}

export function PixSection({ className }: PixSectionProps) {
  const pagamentos = usePrenotaStore((state) => state.draft.pagamentos);
  const setPagamentos = usePrenotaStore(
    (state) => state.actions.draft.setPagamentos
  );

  const handlePixChange = (field: "chavePix" | "cnpjPix", value: string) => {
    console.log(
      "%c[PIX] Atualizando campo:",
      "color:#8b5cf6;font-weight:bold",
      {
        field,
        value,
        valorAnterior: pagamentos[field],
      }
    );

    setPagamentos({
      ...pagamentos,
      [field]: field === "cnpjPix" ? value.replace(/\D/g, "") : value,
    });
  };

  // Verifica se há dados PIX preenchidos
  const hasPixData = !!(pagamentos.chavePix || pagamentos.cnpjPix);

  return (
    <Accordion type="single" collapsible className={className}>
      <AccordionItem value="pix-data" className="border-none">
        <AccordionTrigger className="hover:no-underline" iconClassName="hidden">
          <div className="flex items-center gap-2">
            <Label className="text-xs font-medium text-muted-foreground">
              Dados PIX
            </Label>
            {hasPixData && (
              <span className="w-2 h-2 bg-green-500 rounded-full"></span>
            )}
          </div>
          <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </AccordionTrigger>
        <AccordionContent className="pb-2 pt-2">
          <div className="space-y-3">
            <div>
              <Label className="text-xs text-muted-foreground mb-1 block">
                Chave PIX
              </Label>
              <Input
                value={pagamentos.chavePix || ""}
                onChange={(e) => handlePixChange("chavePix", e.target.value)}
                placeholder="E-mail, CPF/CNPJ, telefone..."
                className="text-xs"
              />
            </div>
            <div>
              <Label className="text-xs text-muted-foreground mb-1 block">
                CPF/CNPJ Destinatário
              </Label>
              <Input
                value={pagamentos.cnpjPix || ""}
                onChange={(e) => handlePixChange("cnpjPix", e.target.value)}
                placeholder="Somente números"
                maxLength={14}
                className="text-xs"
              />
            </div>
          </div>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
}
